module.exports = __webpack_public_path__ + "static/media/galleryImg8.0735db22.jpg";